"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faMegaphone_1 = require("@fortawesome/pro-light-svg-icons/faMegaphone");
var faBug_1 = require("@fortawesome/pro-regular-svg-icons/faBug");
var faQuestion_1 = require("@fortawesome/pro-solid-svg-icons/faQuestion");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var CircleIconButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/CircleIconButton"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var TypeformPopupButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TypeformPopupButton"));
var single_1 = require("utils/selectors/single");
var NotificationsDropdown_1 = __importDefault(require("./NotificationsDropdown"));
var SiteMenu_1 = __importDefault(require("./SiteMenu"));
var ProfileActions = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", flexWrap: "wrap", pr: 2.5 }, { children: [profile.isAdmin && ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ml: 1, mr: 2 }, { children: (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ icon: faBug_1.faBug, size: "small", href: "https://forms.gle/qiuae9EjZkLxVy3XA", targetUrl: "_blank" }, { children: "Report a Bug" })) }))), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 2 }, { children: (0, jsx_runtime_1.jsx)(TypeformPopupButton_1.default, __assign({ typeFormID: "m77kfiqb", icon: faMegaphone_1.faMegaphone, variant: "outlined", size: "small", hidden: {
                        user_id: profile.id,
                        email: profile === null || profile === void 0 ? void 0 : profile.email,
                        company: profile === null || profile === void 0 ? void 0 : profile.companyId,
                    } }, { children: "Got Feedback?" })) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 84, display: "flex", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(NotificationsDropdown_1.default, {}), (0, jsx_runtime_1.jsx)(CircleIconButton_1.default, { isCircle: true, color: "neutral", icon: faQuestion_1.faQuestion, iconSize: 14, url: "https://intercom.help/hudled/en/", targetUrl: "_blank" }), (0, jsx_runtime_1.jsx)(SiteMenu_1.default, {})] }))] })));
};
exports.default = ProfileActions;
